/**
 * Met en forme le libellé d'une prestation pour l'affichage.
 *
 * Les libellés proviennent de sources hétérogènes : le catalogue HiTech les stocke
 * intégralement en capitales (`CAUTION`), les toggles et le bloc Pneus stockent une clé
 * d'enum (`Remise_en_etat`), et la saisie en texte libre n'impose rien. Cette fonction
 * uniformise leur rendu : underscores remplacés par des espaces, minuscules, capitale initiale.
 *
 * ⚠️ Fonction de rendu pure, à appliquer au dernier moment. Le `name` d'un benefit est une clé
 * d'identité (comparaisons des toggles, `isPneuBenefit`, statistiques dossier, résolution
 * legacy côté API) : ne jamais réinjecter la valeur formatée dans le state ni dans un payload API.
 */
export const formatPrestationLabel = (name) => {
  const texte = String(name ?? "").trim();

  // Review sprint20 — seuls les libellés bruts sont reformatés : tout en
  // capitales (catalogue HiTech, texte libre tapé en majuscules) ou porteurs
  // d'underscores (clés d'enum). Un libellé rédigé à la main garde sa casse,
  // sinon « Assurance RC Pro » deviendrait « Assurance rc pro » sur le PDF.
  if (!/_/.test(texte) && texte !== texte.toUpperCase()) {
    return texte;
  }

  const cleaned = texte.replace(/_/g, " ").toLowerCase();

  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
};
